// eslint-disable-next-line
import { useLocation } from '@reach/router';

export default function useLocationData() {
    const location = useLocation();
    const url = location.pathname.slice(1, -1).split('/');

    const replace = (text: string) => text.replaceAll('-', ' ');

    const category = url.length >= 2 ? replace(url[0]) : '';
    const subCategory = url.length === 3 ? replace(url[1]) : '';
    const pageTitle =
        url.length === 1 ? url[0] : url.length === 2 ? url[1] : url.length === 3 ? url[2] : '';
    let title = replace(pageTitle);

    if (title === 'zo') {
        title = 'ZO';
    } else if (title === 'biojuve') {
        title = 'bioJuve';
    } else if (title === 'skinceuticals') {
        title = 'skinCeuticals';
    } else if (title === 'iv therapy') {
        title = 'IV Therapy';
    } else if (title === 'bridal bridesmaids package') {
        title = 'bridal / bridesmaids package';
    }

    return { category, subCategory, title, pageTitle };
}
